import styled from '@emotion/styled'

export const StyleContentWrapper = styled.div<{
  bgColor?: string
  paddingTop?: string
  paddingBottom?: string
  paddingLeft?: string
  paddingRight?: string
  stretch?: boolean
}>`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  justify-content: center;
  align-items: ${(props) => (props.stretch ? 'stretch' : 'center')};
  background-color: ${(props: any) => props.bgColor || '#ffffff'};
  height: auto;
  padding-top: ${(props: any) => props.paddingTop || 0}px;
  padding-bottom: ${(props: any) => props.paddingBottom || 0}px;
  padding-left: ${(props: any) => props.paddingLeft || 0}px;
  padding-right: ${(props: any) => props.paddingRight || 0}px;

  @media (max-width: 768px) {
    padding-left: 8px;
    padding-right: 8px;
  }
`
